// Relocate .card-stock-pill-wrap from inside .card-gallery (where it
// renders as an absolute overlay on the image) to inline directly
// above the product price — matches the V4 collection-card spec
// (mockup: brand → title → spec → rating → pill → price → ATC).
// Customizer-managed templates/collection.json cannot be edited by
// hand, so we accept the gallery-block render location and move the
// node client-side. CSS in snippets/product-card.liquid switches the
// pill to position: static so the relocation is purely a DOM move.
//
// Lives in /assets so it can be loaded directly on PDP — Shopify's
// block-scripts bundle gates `_product-card-gallery`'s JS behind the
// block being registered in `__blocks__`, and on PDP the gallery
// block is nested inside the async-fetched product-recommendations
// section so it never registers. Loading via plain <script src=>
// from blocks/product-recommendations.liquid sidesteps that gate.
(function () {
    if (window.__psStockPillRelocator) return;
    window.__psStockPillRelocator = true;

    function relocate(card) {
        if (!card || card.dataset.psPillMoved === '1') return;
        var pill = card.querySelector('.card-stock-pill-wrap');
        if (!pill) return;
        // Skip the zoom-out fallback product-price — it lives in a hidden
        // .product-grid-view-zoom-out--details container and would hide the pill.
        var prices = card.querySelectorAll('product-price');
        var priceEl = null;
        for (var i = 0; i < prices.length; i++) {
            if (!prices[i].closest('.product-grid-view-zoom-out--details')) {
                priceEl = prices[i];
                break;
            }
        }
        if (!priceEl || !priceEl.parentElement) return;
        priceEl.parentElement.insertBefore(pill, priceEl);
        card.dataset.psPillMoved = '1';
    }

    function relocateAll() {
        document.querySelectorAll('product-card').forEach(relocate);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', relocateAll, { once: true });
    } else {
        relocateAll();
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.tagName === 'PRODUCT-CARD') relocate(node);
                if (node.querySelectorAll) node.querySelectorAll('product-card').forEach(relocate);
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
})();
